export default {
    title: 'Neue Maßnahme anlegen',
    organisation: 'Antragsteller',
    creatorUser: 'Ansprechperson',
    form: 'Formular',
    year: 'Jahr',
    createProcess: 'Neue Maßnahme anlegen',
    createAndEditProcess: 'Erstellen und weiter bearbeiten',
    createProcessSuccess: 'Die Maßnahme wurde erfolgreich erstellt.',
    createProcessError: 'Die Maßnahme konnte nicht erstellt werden.',
}